var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAglogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1286.464,
    height: 742.09,
    viewBox: "0 0 1286.464 742.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ba7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#3453a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#2c358a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-316.768 -166.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 221.737,
    cy: 221.737,
    r: 221.737,
    transform: "translate(738.263 171.434)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 9.918
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M819.613,282.7l227.406-.051L1100.387,503.7h-62.213L999.418,342.96H834.227Zm95.355,109.53L843.451,503.7h66l71.516-111.474Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M973.091,806.666q-15.966,21.762-44.767,31.775l11.331,20.926-28.7,44.762-42.733-58.174h-31.3l-11.583,58.23H763.345l43.828-219.141h93.6q41.946,0,65.116,18.471t23.164,51.341Q989.056,784.908,973.091,806.666Zm-55.724-66.054q-9.084-6.729-25.356-6.731H859.453L846.3,798.057h36.939q20.667,0,31.935-9.7T926.445,760.8Q926.445,747.349,917.367,740.612ZM702.834,851.905a76.837,76.837,0,0,1-29.113,5.32q-26.61,0-41.323-13.3t-14.715-35.846q0-21.908,9.081-39.131a67.2,67.2,0,0,1,25.827-27.079Q669.337,732,691.567,732q17.531,0,30.366,5.479t23.477,18.627s23.728-36.936,31.49-49.1q-29.925-26.346-82.518-26.346-41.016,0-72.625,16.905-31.626,16.9-49.152,46.8a126,126,0,0,0-15.836,44.994L577.124,873.9A93.2,93.2,0,0,0,607.2,896.511q24.887,12.048,58.072,12.055a162.89,162.89,0,0,0,47.118-6.732,122.705,122.705,0,0,0,39.286-19.563l18.472-92.352H715.36Zm629.338-61.986h54.785l-8.92,44.6s-34.695,54.125-41.64,64.946q-3.526,1.269-7.2,2.373a162.919,162.919,0,0,1-47.118,6.731q-33.186,0-58.071-12.055t-38.505-33.965q-13.617-21.909-13.62-50.4,0-37.873,17.533-67.776t49.151-46.8q31.613-16.905,72.626-16.905,52.592,0,82.517,26.346c-7.762,12.164-31.49,49.1-31.49,49.1q-10.644-13.147-23.477-18.627T1308.379,732q-22.232,0-38.975,9.863a67.2,67.2,0,0,0-25.827,27.079q-9.084,17.22-9.082,39.131,0,22.539,14.715,35.846t41.323,13.3a76.842,76.842,0,0,0,29.114-5.32Zm-245.274-41.2.006-.008h0l40.835-63.677h-61.048L926.128,904.178h61.081Zm45.331-45.088-41.322,64.412,9.907,47.848h-40.6L1030.887,861.6h79.319l8.765,42.575h61.674Zm377.257,45.088.005-.008h0l40.835-63.677h-61.048l-140.562,219.14H1409.8Zm45.33-45.088-41.322,64.412L1523.4,815.9h-40.6L1453.475,861.6h79.318l8.765,42.575h61.674Zm-1036.438-18.6H457.33L316.768,904.178h61.08Zm4.49,18.6-41.322,64.411,9.908,47.849H450.849L421.526,861.6h79.319l8.765,42.575h61.674Z",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAglogo);
export default __webpack_public_path__ + "static/media/aglogo.bd38d611b407c36a1a22ae65066fceca.svg";
export { ForwardRef as ReactComponent };